import { render, staticRenderFns } from "./OwnerFeedback.vue?vue&type=template&id=1d9fd3ac&scoped=true&"
import script from "./OwnerFeedback.vue?vue&type=script&lang=js&"
export * from "./OwnerFeedback.vue?vue&type=script&lang=js&"
import style0 from "./OwnerFeedback.vue?vue&type=style&index=0&id=1d9fd3ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9fd3ac",
  null
  
)

export default component.exports